import PropTypes from "prop-types";
import React, { createContext, useContext } from "react";
import useAuth from "hooks/useAuth";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const { user } = useAuth();
  const stored_permissions = user?.permissions ?? [];
  const permissions = stored_permissions;

  const hasPermission = (permission) => {
    if (user?.is_admin == true || user?.is_owner == true || permission == "any") {
      return true;
    }
    if (permissions) {
      return permissions.includes(permission);
    }
    return false;
  };

  const userHasPermission = (permission) => {
    if (permissions) {
      return permissions.includes(permission);
    }
    return false;
  };

  return (
    <PermissionsContext.Provider value={{ permissions, hasPermission, userHasPermission }}>
      {children}
    </PermissionsContext.Provider>
  );
};

PermissionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const usePermissions = () => useContext(PermissionsContext);
